import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieHotspotBig.json';

import './HotspotBig.scss';

const HotspotBig = (props) => (
    <Icon iconName="HotspotBig" {...props}>
        {document.documentMode || /Edge\//.test(navigator.userAgent) || /Edg\//.test(navigator.userAgent) ? (
            <>
                <div className="HotspotBig__win10">
                    <svg viewBox="0 0 80 80">
                        <circle className="circle__lg" strokeWidth="0" cx="40" cy="40" r="40" opacity="0.3" fill="#fff" />
                        <circle className="circle__sm" strokeWidth="0" cx="40" cy="40" r="25.5" fill="#fff" />
                        <path
                            className="circle__plus"
                            strokeWidth="0"
                            fill="#716f72"
                            d="M49.5 38.25h-7.75V30.5h-3.5v7.75H30.5v3.5h7.75v7.75h3.5v-7.75h7.75v-3.5z"
                        />
                    </svg>
                </div>
            </>
        ) : (
            <LottieAnimation autoplay animationData={animationData} />
        )}
    </Icon>
);

export default HotspotBig;
